$(document).ready(function () {
    // Sätt focus efter texten
    var num = $('#srchTxt').val();
    $('#srchTxt').focus().val('').val(num);

    // Aktivera sökknappen
    if ($('#srchTxt').val().length > 0) {
        $('#sok-submit').attr('disabled', false);
    } else {
        $('#sok-submit').attr('disabled', true);
    }

    // Avaktivera autocomplete
    $('#srchTxt').attr('autocomplete', 'off');

    // Snurrande ikon
    $('#sok-submit').click(function () {
        $('div.sokresultatblock').addClass('dynamisktinnehall-laddar');
    });

    // Logik vid tangenttryck
    $('#srchTxt').keyup(function () {
        if ($('#srchTxt').val().trim().length === 0) {
            $('#sok-submit').attr('disabled', true);
        } else {
            $('#sok-submit').attr('disabled', false);
        }
    });
});
